// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1qdv3","clinicsSelect":"TableHeading_clinicsSelect__3lCxB"};